// Copyright (c) 2016 Deere & Company

import './claim-details.scss';
import React, {PropTypes} from 'react';
import Claim from '@deere/cps-it.warranty-model-factory/lib/claim';
import ClaimTitle from './claim-title';
import LabeledSmartFormLink from '../../../shared/components/labeled-smart-form-link/labeled-smart-form-link';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import SmartFormLink from '../../../shared/components/smart-form-link/smart-form-link';
import {buildClaimRoutes} from '../../../shared/services/build-claim-route';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';
import {buildUseAmountList} from '../../shared/services/product';
import {formatClaimNumberTitle} from '../../../shared/services/format-claim-number';

const ClaimDetails = props =>
    <section className='claim-details'>
        <div className='claim-details-header'>
            {props.claim.isSubmittingDealer ?
                <Link
                    className='claim-details-description'
                    to={buildClaimRoutes(props.claim.claimType.key, props.claim.subClaimType.key, props.claim.id)}
                >
                    <ClaimTitle claimId={props.claim.id}/>
                </Link> :
                <SmartFormLink
                    displayText={formatClaimNumberTitle(props.claim.id)}
                    formName='CLAIM'
                    objectId={props.claim.id}
                />
            }
            <span className='claim-details-status'>
                {props.claim.status}
            </span>
        </div>
        <div className='claim-data'>
            <div className='row'>
                <LabeledString
                    data={props.claim.claimType.value}
                    label='CLAIM_TYPE'
                />
                <LabeledString
                    data={props.claim.referenceNumber1}
                    label='WORK_ORDER_ONE'
                />
                <LabeledString
                    data={buildDate(props.claim.failDate)}
                    label='FAILED'
                />
            </div>
            <div className='row'>
                <LabeledString
                    data={props.claim.customerSummary.displayName}
                    label='CUSTOMER'
                />
                <LabeledString
                    data={props.claim.referenceNumber2}
                    label='WORK_ORDER_TWO'
                />
                <LabeledString
                    data={buildDate(props.claim.repairDate)}
                    label='REPAIRED'
                />
            </div>
            <div className='row'>
                <LabeledString
                    data={buildUseAmountList(props.claim.useAmounts)}
                    label='AMOUNT_OF_USE'
                />
                <LabeledString
                    data={props.claim.failurePart}
                    label='FAILED_PART'
                />
                <LabeledString
                    data={buildDate(props.claim.processDate)}
                    label='PROCESSED'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='two-column'
                    data={buildDealer(props.claim.dealer)}
                    label='DEALER_LOCATION'
                />
                {props.claim.isSubmittingDealer ?
                    <LabeledSmartFormLink
                        displayText={props.claim.creditMemo}
                        formName='CREDITMEMO'
                        label='CREDIT_MEMO'
                        objectId={props.claim.creditMemo}
                    /> :
                        <LabeledString
                            data={props.claim.creditMemo}
                            label='CREDIT_MEMO'
                        />
                }
            </div>
        </div>
    </section>;

ClaimDetails.displayName = 'ClaimDetails';
ClaimDetails.propTypes = {
    claim: PropTypes.instanceOf(Claim).isRequired
};

export default ClaimDetails;



// WEBPACK FOOTER //
// ./src/product/details/components/claim-details.js